<template>
    <div>
        <el-dialog
            :visible.sync="visible"
            :before-close="handleClose"
            :close-on-click-modal="false"
            width="600px"
        >
            <template slot="title">
                <h5 class="text-dark mb-0">Submit Voice Integrity</h5>
            </template>

            <el-form
                ref="viForm"
                :model="form"
                :rules="formRules"
                label-position="top"
            >
                <div class="row">
                    <div class="col-12">
                        <p class="text-muted mb-3">
                            Register your phone numbers for Voice Integrity to reduce spam labels and improve call quality.
                        </p>

                        <el-form-item label="How will you primarily use your phone numbers for calls?" prop="voice_integrity_use_case">
                            <el-select
                                v-model="form.voice_integrity_use_case"
                                class="w-full"
                                placeholder="Select a use case"
                                filterable
                                clearable
                            >
                                <el-option
                                    v-for="use_case in voiceIntegrityUseCases"
                                    :key="use_case"
                                    :value="use_case"
                                    :label="use_case"
                                />
                            </el-select>
                        </el-form-item>

                        <div class="row">
                            <div class="col-md-6">
                                <el-form-item label="Number of Employees" prop="business_employee_count">
                                    <el-input-number
                                        v-model="form.business_employee_count"
                                        :min="1"
                                        class="w-100"
                                        controls-position="right"
                                        placeholder="Enter number of employees"
                                    />
                                </el-form-item>
                            </div>

                            <div class="col-md-6">
                                <el-form-item label="Average Calls per Business Day" prop="average_business_day_call_volume">
                                    <el-input-number
                                        v-model="form.average_business_day_call_volume"
                                        :min="1"
                                        controls-position="right"
                                        class="w-100"
                                        placeholder="Enter estimated calls per day"
                                    />
                                </el-form-item>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="row mt-2">
                            <div class="col-md-12 text-right">
                                <el-button @click="handleClose">
                                    Cancel
                                </el-button>
                                <el-button
                                    type="primary"
                                    :loading="submitting"
                                    class="ml-2"
                                    @click="submit"
                                >
                                    Submit
                                </el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import {VOICE_INTEGRITY_USE_CASES} from '../../../constants/compliance/voice-integrity-use-cases'

export default {
    name: 'VoiceIntegrityRegistrationDialog',

    props: {
        visible: {
            type: Boolean,
            required: true,
        },
        company: {
            type: Object,
            default: null,
        },
    },

    data() {
        return {
            voiceIntegrityUseCases: VOICE_INTEGRITY_USE_CASES,
            submitting: false,
            form: {
                voice_integrity_use_case: '',
                business_employee_count: null,
                average_business_day_call_volume: null,
            },
            formRules: {
                voice_integrity_use_case: [
                    {required: true, message: 'Please select a use case', trigger: 'change'},
                ],
                business_employee_count: [
                    {required: true, message: 'Please enter the number of employees', trigger: 'blur'},
                    {type: 'number', min: 1, message: 'Must be at least 1', trigger: 'blur'},
                ],
                average_business_day_call_volume: [
                    {required: true, message: 'Please enter average calls per business day', trigger: 'blur'},
                    {type: 'number', min: 1, message: 'Must be at least 1', trigger: 'blur'},
                ],
            },
        }
    },

    watch: {
        visible(newVal) {
            if (newVal) {
                this.prefillFromCompany()
                this.$nextTick(() => {
                    if (this.$refs.viForm) {
                        this.$refs.viForm.clearValidate()
                    }
                })
            }
        },
    },

    methods: {
        prefillFromCompany() {
            if (this.company) {
                this.form.voice_integrity_use_case = this.company.voice_integrity_use_case || ''
                this.form.business_employee_count = this.company.business_employee_count || null
                this.form.average_business_day_call_volume = this.company.average_business_day_call_volume || null
            }
        },

        handleClose() {
            this.$emit('close')
        },

        submit() {
            this.$refs.viForm.validate(valid => {
                if (!valid) return

                this.submitting = true

                axios.post('/api/v1/compliance/voice-integrity-bundle', this.form)
                    .then(() => {
                        this.$notify({
                            title: 'Voice Integrity',
                            message: 'Your registration is being processed.',
                            type: 'success',
                            showClose: true,
                        })
                        this.$emit('submitted')
                        this.handleClose()
                    })
                    .catch(err => {
                        this.$root.handleErrors(err.response)
                    })
                    .finally(() => {
                        this.submitting = false
                    })
            })
        },
    },
}
</script>
